export function showConfirm(message, title = 'ยืนยันการทำรายการ') {
  return new Promise((resolve) => {
    // Remove existing if any
    const existing = document.getElementById('custom-dialog-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'custom-dialog-overlay';
    overlay.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
      background: rgba(0,0,0,0.6); backdrop-filter: blur(4px);
      display: flex; align-items: center; justify-content: center;
      z-index: 9999; opacity: 0; transition: opacity 0.2s ease;
    `;

    const dialog = document.createElement('div');
    dialog.style.cssText = `
      background: var(--bg-card, #1a1a1a);
      border: 1px solid var(--border-color, #333);
      border-radius: var(--radius-lg, 16px);
      padding: var(--space-lg, 24px);
      width: 90%; max-width: 320px;
      text-align: center;
      box-shadow: 0 10px 30px rgba(0,0,0,0.5);
      transform: scale(0.9); transition: transform 0.2s ease;
    `;

    dialog.innerHTML = `
      <div style="font-size: 24px; margin-bottom: 12px;">✨</div>
      <h3 style="color: var(--accent-gold, #D4AF37); margin-bottom: 12px; font-size: 18px;">${title}</h3>
      <p style="color: var(--text-muted, #aaa); margin-bottom: 24px; font-size: 14px; line-height: 1.5;">${message}</p>
      <div style="display: flex; gap: 12px; justify-content: center;">
        <button id="dialog-cancel" style="flex:1; padding: 10px; border-radius: 8px; border: 1px solid var(--border-color, #444); background: transparent; color: var(--text-muted, #aaa); cursor: pointer; font-weight: bold;">ยกเลิก</button>
        <button id="dialog-confirm" style="flex:1; padding: 10px; border-radius: 8px; border: none; background: var(--gradient-primary, linear-gradient(135deg, #D4AF37 0%, #AA8222 100%)); color: #111; cursor: pointer; font-weight: bold;">ตกลง</button>
      </div>
    `;

    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    // Animate in
    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
      dialog.style.transform = 'scale(1)';
    });

    const closeDialog = (result) => {
      overlay.style.opacity = '0';
      dialog.style.transform = 'scale(0.9)';
      setTimeout(() => {
        overlay.remove();
        resolve(result);
      }, 200);
    };

    document.getElementById('dialog-cancel').onclick = () => closeDialog(false);
    document.getElementById('dialog-confirm').onclick = () => closeDialog(true);
  });
}

export function showAlert(message, title = 'แจ้งเตือน') {
  return new Promise((resolve) => {
    // Remove existing if any
    const existing = document.getElementById('custom-dialog-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'custom-dialog-overlay';
    overlay.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
      background: rgba(0,0,0,0.6); backdrop-filter: blur(4px);
      display: flex; align-items: center; justify-content: center;
      z-index: 9999; opacity: 0; transition: opacity 0.2s ease;
    `;

    const dialog = document.createElement('div');
    dialog.style.cssText = `
      background: var(--bg-card, #1a1a1a);
      border: 1px solid var(--border-color, #333);
      border-radius: var(--radius-lg, 16px);
      padding: var(--space-lg, 24px);
      width: 90%; max-width: 320px;
      text-align: center;
      box-shadow: 0 10px 30px rgba(0,0,0,0.5);
      transform: scale(0.9); transition: transform 0.2s ease;
    `;

    dialog.innerHTML = `
      <div style="font-size: 24px; margin-bottom: 12px;">🔔</div>
      <h3 style="color: var(--accent-gold, #D4AF37); margin-bottom: 12px; font-size: 18px;">${title}</h3>
      <p style="color: var(--text-muted, #aaa); margin-bottom: 24px; font-size: 14px; line-height: 1.5;">${message}</p>
      <button id="dialog-ok" style="width: 100%; padding: 12px; border-radius: 8px; border: none; background: var(--gradient-primary, linear-gradient(135deg, #D4AF37 0%, #AA8222 100%)); color: #111; cursor: pointer; font-weight: bold;">ปิด</button>
    `;

    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    // Animate in
    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
      dialog.style.transform = 'scale(1)';
    });

    const closeDialog = () => {
      overlay.style.opacity = '0';
      dialog.style.transform = 'scale(0.9)';
      setTimeout(() => {
        overlay.remove();
        resolve(true);
      }, 200);
    };

    document.getElementById('dialog-ok').onclick = closeDialog;
  });
}

export function showPrompt(message, title = 'ป้อนข้อมูล', defaultValue = '') {
  return new Promise((resolve) => {
    // Remove existing if any
    const existing = document.getElementById('custom-dialog-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'custom-dialog-overlay';
    overlay.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
      background: rgba(0,0,0,0.6); backdrop-filter: blur(4px);
      display: flex; align-items: center; justify-content: center;
      z-index: 9999; opacity: 0; transition: opacity 0.2s ease;
    `;

    const dialog = document.createElement('div');
    dialog.style.cssText = `
      background: var(--bg-card, #1a1a1a);
      border: 1px solid var(--border-color, #333);
      border-radius: var(--radius-lg, 16px);
      padding: var(--space-lg, 24px);
      width: 90%; max-width: 320px;
      text-align: center;
      box-shadow: 0 10px 30px rgba(0,0,0,0.5);
      transform: scale(0.9); transition: transform 0.2s ease;
    `;

    dialog.innerHTML = `
      <div style="font-size: 24px; margin-bottom: 12px;">✍️</div>
      <h3 style="color: var(--accent-gold, #D4AF37); margin-bottom: 12px; font-size: 18px;">${title}</h3>
      <p style="color: var(--text-muted, #aaa); margin-bottom: 16px; font-size: 14px; line-height: 1.5;">${message}</p>
      <input type="text" id="dialog-input" value="${defaultValue}" style="width: 100%; padding: 12px; margin-bottom: 24px; border-radius: 8px; border: 1px solid var(--border-color, #444); background: var(--bg-color, #111); color: #fff; font-size: 16px; text-align: center; box-sizing: border-box;" autocomplete="off" />
      <div style="display: flex; gap: 12px; justify-content: center;">
        <button id="dialog-cancel" style="flex:1; padding: 10px; border-radius: 8px; border: 1px solid var(--border-color, #444); background: transparent; color: var(--text-muted, #aaa); cursor: pointer; font-weight: bold;">ยกเลิก</button>
        <button id="dialog-confirm" style="flex:1; padding: 10px; border-radius: 8px; border: none; background: var(--gradient-primary, linear-gradient(135deg, #D4AF37 0%, #AA8222 100%)); color: #111; cursor: pointer; font-weight: bold;">ตกลง</button>
      </div>
    `;

    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    
    // Focus input
    const inputEl = document.getElementById('dialog-input');
    inputEl.focus();
    
    // Allow enter to submit
    inputEl.addEventListener('keyup', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        document.getElementById('dialog-confirm').click();
      }
    });

    // Animate in
    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
      dialog.style.transform = 'scale(1)';
    });

    const closeDialog = (result) => {
      overlay.style.opacity = '0';
      dialog.style.transform = 'scale(0.9)';
      setTimeout(() => {
        overlay.remove();
        resolve(result);
      }, 200);
    };

    document.getElementById('dialog-cancel').onclick = () => closeDialog(null);
    document.getElementById('dialog-confirm').onclick = () => closeDialog(inputEl.value);
  });
}
